(() => {
  const mq = window.matchMedia("(min-width: 990px)");
  if (!mq.matches) return;

  const header = document.querySelector("sticky-header") || document.querySelector("#shopify-section-header") || document.querySelector("header");
  if (!header) return;

  // Nur Mega-Menüs im Header
  const menus = Array.from(header.querySelectorAll('header-menu details.mega-menu'));
  if (!menus.length) return;

  const CLOSE_DELAY = 220; // bei Bedarf 300
  let closeTimer = null;
  let activeDetails = null;

  const isPointerInsideHeaderOrPanel = (details) => {
    if (!details) return false;
    const panel = details.querySelector(".mega-menu__content");
    return details.matches(":hover") || (panel && panel.matches(":hover")) || header.matches(":hover");
  };

  const openMenu = (details) => {
    if (!details) return;
    clearTimeout(closeTimer);
    activeDetails = details;
    details.setAttribute("open", "");
    const summary = details.querySelector("summary");
    if (summary) summary.setAttribute("aria-expanded", "true");
  };

  const scheduleClose = (details) => {
    clearTimeout(closeTimer);
    closeTimer = setTimeout(() => {
      if (!isPointerInsideHeaderOrPanel(details)) {
        details.removeAttribute("open");
        const summary = details.querySelector("summary");
        if (summary) summary.setAttribute("aria-expanded", "false");
        if (activeDetails === details) activeDetails = null;
      }
    }, CLOSE_DELAY);
  };

  // 1) Öffnen beim Hover auf Summary
  menus.forEach((details) => {
    const summary = details.querySelector("summary");
    const panel = details.querySelector(".mega-menu__content");
    if (!summary || !panel) return;

    summary.addEventListener("mouseenter", () => openMenu(details));
    panel.addEventListener("mouseenter", () => openMenu(details));

    details.addEventListener("mouseleave", () => scheduleClose(details));
    panel.addEventListener("mouseleave", () => scheduleClose(details));
  });

  // 2) KRITISCH: Dawn/Katalyst schließt teils bei globalen Events.
  // Wir halten das aktive Menü offen, solange Maus im Header/Panel ist.
  // Capturing, damit wir vor anderen Listenern laufen.
  ["mousemove", "mouseenter"].forEach((evt) => {
    document.addEventListener(
      evt,
      () => {
        if (!activeDetails) return;
        // Wenn wir im Header/Panel sind, erzwinge open
        if (isPointerInsideHeaderOrPanel(activeDetails)) {
          activeDetails.setAttribute("open", "");
        }
      },
      true
    );
  });

  // 3) Wenn Maus wirklich weg ist (unterhalb), dann schließen (delayed)
  document.addEventListener(
    "mousemove",
    () => {
      if (!activeDetails) return;
      if (!isPointerInsideHeaderOrPanel(activeDetails)) {
        scheduleClose(activeDetails);
      }
    },
    true
  );

  // 4) Click außerhalb schließt
  document.addEventListener("click", (e) => {
    if (!activeDetails) return;
    if (!activeDetails.contains(e.target)) {
      activeDetails.removeAttribute("open");
      const summary = activeDetails.querySelector("summary");
      if (summary) summary.setAttribute("aria-expanded", "false");
      activeDetails = null;
    }
  });
})();
